module.exports = __webpack_public_path__ + "img/Frame-99.5c6ca6cf.svg";